import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { setSoundAction, playSoundAction, clearSoundAction } from "../../../../../redux/sound";

const EntryPopup = () => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const dispatch = useDispatch();
  const setSound = payload => { dispatch( setSoundAction( payload ) ) };
  const playSound = () => { dispatch( playSoundAction() ) };
  const clearSound = () => { dispatch( clearSoundAction() ) };

  const { t } = useTranslation();

  useEffect( () => {
    setSound( { src : `${ process.env.PUBLIC_URL }/static/audio/lc_05_02_open.ogg` } );
    playSound();
    return () => {
      setTimeout( clearSound );
    };
  }, [] );

  return (
    <div className="lp-wrap lp-middle nothead gb">
      <div className="lp-container lc-alert type2 h_auto">
        <p className="lc-alert_txt fwm" dangerouslySetInnerHTML={ { __html : 'Y' === answeringQuestions.data.hstMsgYn ? t( 'LC_05_20.msg002' ) : t( 'LC_05_20.msg001' ) } } />
        <div className="lc-alert_aniBtm" />
      </div>
    </div>
  );

};

export default EntryPopup;
